import { HttpClient } from '../../httpClient'
import type { OpalApiResponseDocument } from '../../schema'

type CreateAssetV2ResponseData = OpalApiResponseDocument<'CreateAssetV2', 201>

const getConfig = (file: File) => {
  // Encode the header as Base64 to support UTF-8 Unicode characters
  const encodedFileName = window.btoa(unescape(encodeURIComponent(file.name)))

  return {
    headers: {
      'Content-Type': 'application/octet-stream',
      'X-File-Name': encodedFileName,
    },
  } as const
}

export const createAsset = async (
  file: File
): Promise<CreateAssetV2ResponseData> => {
  const url = new URL('/assets/v2', window.location.origin)

  return HttpClient()
    .post<CreateAssetV2ResponseData>(url.toString(), file, getConfig(file))
    .then((res) => res.data)
}
